import "@Styles/Controls/BrowsePath/browsePath_sm.less";
import "@Styles/Controls/BrowsePath/browsePath_md.less";
import "@Styles/Controls/BrowsePath/browsePath_lg.less";
export default {
  data: function data() {
    return {
      config: {},
      isShowAllState: false,
      hasOverflowItems: false,
      componentsLoaded: false
    };
  },
  methods: {
    init: function init(config) {
      this.config = config || {};

      if (this.config.links && this.config.links.some(function (link) {
        return link.isOverflow;
      })) {
        this.hasOverflowItems = true;
      }

      this.componentsLoaded = true;
    },
    toggleisOverflow: function toggleisOverflow() {
      this.isShowAllState = !this.isShowAllState;
    }
  }
};